@if (Company) {
  <form
    #clientRegisteredVendorComponent
    class="container-fluid"
    [formGroup]="ClientRegisteredVendorForm"
  >
    @if (addingClientRegisteredVendor) {
      <div class="row row-padding-top">
        <div class="col">
          <h2>
            {{ addingClientRegisteredVendor ? 'Add' : 'Edit' }}
            {{
              isBusinessVerifiedVendor ? 'Business Verified' : 'Non-Verified'
            }}
            Vendor
          </h2>
        </div>
      </div>
    }
    <div class="row my-3">
      <div class="col">
        <div class="row g-3">
          <div class="col">
            <h3>Company Information</h3>
            <hr />
            <div class="row align-items-center">
              <div class="col-auto">
                <label class="form-check-label">
                  Transition Vendor?
                  <i
                    class="bi bi-question-circle"
                    name="popover"
                    data-bs-placement="top"
                    [attr.data-bs-content]="'New vendors due to a take-over property ONLY.'"
                  ></i>
                </label>
                <select
                  class="form-select"
                  (ngModelChange)="isTakeOverChanged()"
                  formControlName="isTakeOver"
                >
                  @for (option of YesNoOptions; track option) {
                    <option [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-2">
                <div class="form-check">
                  <input
                    id="issue1099"
                    type="checkbox"
                    class="form-check-input"
                    formControlName="issue1099"
                  />
                  <label for="issue1099" class="form-check-label"
                    >Issue 1099?</label
                  >
                </div>
              </div>
              @if (CompanyComplianceTypes.length > 0) {
                <div class="col-4">
                  <label for="complianceTypeId"
                    >Compliance Program<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                  <select
                    id="complianceTypeId"
                    class="form-select"
                    [(ngModel)]="CompanyComplianceTypeId"
                    [ngModelOptions]="{ standalone: true }"
                  >
                    <!--<option [ngValue]="null" disabled selected>Pick one...</option>-->
                    @for (type of CompanyComplianceTypes; track type) {
                      <option [ngValue]="type.id">
                        {{ type.type }}
                      </option>
                    }
                  </select>
                </div>
              }
            </div>
            @if (
              isBusinessVerifiedVendor &&
              !ClientRegisteredVendorForm.controls['isTakeOver'].value
            ) {
              <div class="row">
                <div class="col-6">
                  <label for="requesterFirstName" class="form-label"
                    >Requester First Name<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="requesterFirstName"
                    formControlName="requesterFirstName"
                  />
                </div>
                <div class="col-6">
                  <label for="requesterLastName" class="form-label"
                    >Requester Last Name<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="requesterLastName"
                    formControlName="requesterLastName"
                  />
                </div>
              </div>
            }
            @if (Company.country === 'US') {
              <div class="row">
                <div class="col-3">
                  <label
                    class="form-label"
                    [requiredAsterisk]="
                      Company.allowAutomatedBusinessVerificationClientRegisteredVendors
                    "
                    >Tax Identification</label
                  >
                  <select
                    class="form-select"
                    formControlName="taxIdentification"
                  >
                    <option [ngValue]="null" disabled selected>
                      Pick one...
                    </option>
                    @for (option of taxIdentificationOptions; track option) {
                      <option [ngValue]="option">
                        {{ option }}
                      </option>
                    }
                  </select>
                </div>
                @if (
                  ClientRegisteredVendorForm.controls['taxIdentification'].value
                ) {
                  <div class="col-5">
                    <label
                      for="taxSelection"
                      class="form-label"
                      [requiredAsterisk]="
                        Company.allowAutomatedBusinessVerificationClientRegisteredVendors
                      "
                      >Company
                      {{
                        ClientRegisteredVendorForm.controls['taxIdentification']
                          .value
                      }}
                      (Tax ID)</label
                    >
                    @if (
                      ClientRegisteredVendorForm.controls['taxIdentification']
                        .value === 'SSN'
                    ) {
                      <input
                        placeholder="___-__-____"
                        [inputMask]="ssnMask"
                        type="text"
                        class="form-control"
                        id="taxSelection"
                        formControlName="ssn"
                      />
                    }
                    @if (
                      ClientRegisteredVendorForm.controls['taxIdentification']
                        .value === 'EIN'
                    ) {
                      <input
                        placeholder="__-_______"
                        [inputMask]="einMask"
                        type="text"
                        class="form-control"
                        id="taxSelection"
                        formControlName="ein"
                      />
                    }
                  </div>
                }
              </div>
            }
            @if (Company.country === 'CA') {
              <div class="row">
                <div class="col-3">
                  <label class="form-label">GST/HST</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="_________"
                    [inputMask]="gstHstMask"
                    formControlName="bsn"
                  />
                </div>
              </div>
            }
            <div class="row">
              <div class="col-6">
                <label for="legalName" class="form-label"
                  >Legal Name<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="legalName"
                  formControlName="legalName"
                />
              </div>
              <div class="col-6">
                <label for="dba" class="form-label">DBA</label>
                <input
                  type="text"
                  class="form-control"
                  id="dba"
                  formControlName="dba"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label for="accountingId" class="form-label"
                  >Accounting Id</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="accountingId"
                  formControlName="accountingId"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <label for="officePhone" class="form-label">Office Phone</label>
                <input
                  type="text"
                  class="form-control"
                  id="officePhone"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone"
                />
              </div>
              <div class="col-6">
                <label for="website" class="form-label">Website</label>
                <input
                  type="text"
                  class="form-control"
                  id="website"
                  formControlName="website"
                />
              </div>
            </div>
            @if (isBusinessVerifiedVendor) {
              <div class="row">
                <div class="col-4">
                  <label for="stateToVerify"
                    >Select State to search (per W-9 or per Client
                    location)<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                  <select class="form-select" formControlName="stateToVerify">
                    @for (item of states; track item) {
                      <option [ngValue]="item.abbreviation">
                        {{ item.name }}
                      </option>
                    }
                  </select>
                </div>
              </div>
            }
          </div>
        </div>
        <div class="row g-3 mt-3">
          <div class="col">
            <h3>Address Information</h3>
            <hr />
            <div class="row" formGroupName="MailingAddress">
              <div class="col-3">
                <label
                  for="mailingAddress"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.MailingAddress
                        .controls.address1
                    )
                  "
                  >Mailing Address</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="mailingAddress"
                  formControlName="address1"
                />
              </div>
              <div class="col-3">
                <label for="mailingAddress2" class="form-label"
                  >Mailing Address 2</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="mailingAddress2"
                  formControlName="address2"
                />
              </div>
              <div class="col-2">
                <label
                  for="mailingCity"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.MailingAddress
                        .controls.city
                    )
                  "
                  >City</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="mailingCity"
                  formControlName="city"
                />
              </div>
              <div class="col-2">
                <label
                  for="mailingState"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.MailingAddress
                        .controls.state
                    )
                  "
                  >{{
                    LocalizationInfo && LocalizationInfo.territory
                      ? LocalizationInfo.territory.label
                      : 'State'
                  }}</label
                >
                <select class="form-select" formControlName="state">
                  @for (item of states; track item) {
                    <option [ngValue]="item.abbreviation">
                      {{ item.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-2">
                <label
                  for="mailingZip"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.MailingAddress
                        .controls.zip
                    )
                  "
                  >{{
                    LocalizationInfo && LocalizationInfo.postalCode
                      ? LocalizationInfo.postalCode.label
                      : 'Zip'
                  }}</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="mailingZip"
                  formControlName="zip"
                  placeholder="{{
                    LocalizationInfo && LocalizationInfo.postalCode.format
                      ? LocalizationInfo.postalCode.format
                      : ''
                  }}"
                  [inputMask]="zipMask"
                />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-auto">
                <div class="form-check">
                  <input
                    id="isMailingAndStreetSame"
                    type="checkbox"
                    class="form-check-input"
                    (change)="onIsMailingAndStreetSameChange()"
                    [checked]="isMailingAndStreetSame"
                  />
                  <label for="isMailingAndStreetSame" class="form-check-label"
                    >Street Address & Mailing Address are the same</label
                  >
                </div>
              </div>
            </div>
            <div class="row" formGroupName="StreetAddress">
              <div class="col-3">
                <label
                  for="streetAddress"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.StreetAddress.controls
                        .address1
                    )
                  "
                  >Street Address</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="streetAddress"
                  formControlName="address1"
                />
              </div>
              <div class="col-3">
                <label for="streetAddress2" class="form-label"
                  >Street Address 2</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="streetAddress2"
                  formControlName="address2"
                />
              </div>
              <div class="col-2">
                <label
                  for="streetCity"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.StreetAddress.controls
                        .city
                    )
                  "
                  >City</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="streetCity"
                  formControlName="city"
                />
              </div>
              <div class="col-2">
                <label
                  for="streetState"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.StreetAddress.controls
                        .state
                    )
                  "
                  >{{
                    LocalizationInfo && LocalizationInfo.territory
                      ? LocalizationInfo.territory.label
                      : 'State'
                  }}</label
                >
                <select class="form-select" formControlName="state">
                  @for (item of states; track item) {
                    <option [ngValue]="item.abbreviation">
                      {{ item.name }}
                    </option>
                  }
                </select>
              </div>
              <div class="col-2">
                <label
                  for="streetZip"
                  class="form-label"
                  [requiredAsterisk]="
                    checkForRequiredValidators(
                      ClientRegisteredVendorForm.controls.StreetAddress.controls
                        .zip
                    )
                  "
                  >{{
                    LocalizationInfo && LocalizationInfo.postalCode
                      ? LocalizationInfo.postalCode.label
                      : 'Zip'
                  }}</label
                >
                <input
                  type="text"
                  class="form-control"
                  id="streetZip"
                  formControlName="zip"
                  placeholder="{{
                    LocalizationInfo && LocalizationInfo.postalCode.format
                      ? LocalizationInfo.postalCode.format
                      : ''
                  }}"
                  [inputMask]="zipMask"
                />
              </div>
            </div>
          </div>
        </div>
        <form class="row g-3 mt-3" [formGroup]="primaryContactForm">
          <div class="col">
            <h3>Contact Information</h3>
            <hr />
            <div class="row">
              <div class="col"></div>
              <div class="col-auto">
                <label>
                  Offsite Vendor/Supplier?
                  <i
                    class="bi bi-question-circle"
                    name="popover"
                    data-bs-placement="top"
                    [attr.data-bs-content]="'Offsite vendors and suppliers do not require an email and will not be invited to register.'"
                  ></i>
                </label>
                <select
                  class="form-select"
                  (ngModelChange)="isOffsiteChanged()"
                  [formControl]="
                    ClientRegisteredVendorForm.controls['isOffsite']
                  "
                >
                  @for (option of YesNoOptions; track option) {
                    <option [ngValue]="option.value">
                      {{ option.label }}
                    </option>
                  }
                </select>
              </div>
            </div>
            <div class="row g-3">
              <div class="col-4">
                <label for="firstName" class="form-label">First Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="firstName"
                  formControlName="firstName"
                />
              </div>
              <div class="col-4">
                <label for="lastName" class="form-label">Last Name</label>
                <input
                  type="text"
                  class="form-control"
                  id="lastName"
                  formControlName="lastName"
                />
              </div>
              <div class="col-4">
                <label for="jobTitle" class="form-label">Job Title</label>
                <input
                  type="text"
                  class="form-control"
                  id="jobTitle"
                  formControlName="jobTitle"
                />
              </div>
            </div>
            <div class="row g-3">
              <div class="col-3">
                <label for="phone" class="form-label"
                  >Mobile / Primary Phone</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="phone"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone1"
                />
              </div>
              <div class="col">
                <label for="ext" class="form-label">Ext.</label>
                <input
                  type="tel"
                  class="form-control"
                  id="ext"
                  formControlName="ext"
                />
              </div>
              <div class="col-3">
                <label for="phone2" class="form-label"
                  >Work / Secondary Phone</label
                >
                <input
                  type="tel"
                  class="form-control"
                  id="phone2"
                  placeholder="(___)___-____"
                  [inputMask]="phoneMask"
                  formControlName="phone2"
                />
              </div>
              <div class="col">
                <label for="ext2" class="form-label">Ext.</label>
                <input
                  type="tel"
                  class="form-control"
                  id="ext2"
                  formControlName="ext2"
                />
              </div>
              <div class="col-3">
                <label for="email" class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="email"
                  formControlName="email"
                />
              </div>
            </div>
          </div>
        </form>
        @if (additionalContacts && additionalContacts.length > 0) {
          <div class="row mt-3">
            @for (item of additionalContacts; track item; let i = $index) {
              <div [formGroup]="additionalContacts[i]" class="row mt-3">
                <div class="col">
                  <h3>Additional Contact Information</h3>
                  <hr />
                  <div class="row g-3">
                    <div class="col-4">
                      <label
                        for="{{ 'additionalContactFirstName' + i }}"
                        class="form-label"
                        >First Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="{{ 'additionalContactFirstName' + i }}"
                        formControlName="firstName"
                      />
                    </div>
                    <div class="col-4">
                      <label
                        for="{{ 'additionalContactLastName' + i }}"
                        class="form-label"
                        >Last Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="{{ 'additionalContactLastName' + i }}"
                        formControlName="lastName"
                      />
                    </div>
                    <div class="col-4">
                      <label
                        for="{{ 'additionalContactJobTitle' + i }}"
                        class="form-label"
                        >Job Title</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="{{ 'additionalContactJobTitle' + i }}"
                        formControlName="jobTitle"
                      />
                    </div>
                  </div>
                  <div class="row g-3">
                    <div class="col-3">
                      <label
                        for="{{ 'additionalContactPhone' + i }}"
                        class="form-label"
                        >Mobile / Primary Phone</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        id="{{ 'additionalContactPhone' + i }}"
                        placeholder="(___)___-____"
                        [inputMask]="phoneMask"
                        formControlName="phone1"
                      />
                    </div>
                    <div class="col">
                      <label
                        for="{{ 'additionalContactExt' + i }}"
                        class="form-label"
                        >Ext.</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        id="{{ 'additionalContactExt' + i }}"
                        formControlName="ext"
                      />
                    </div>
                    <div class="col-3">
                      <label
                        for="{{ 'additionalContactPhone2' + i }}"
                        class="form-label"
                        >Work / Secondary Phone</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        id="{{ 'additionalContactPhone2' + i }}"
                        placeholder="(___)___-____"
                        [inputMask]="phoneMask"
                        formControlName="phone2"
                      />
                    </div>
                    <div class="col">
                      <label
                        for="{{ 'additionalContactExt2' + i }}"
                        class="form-label"
                        >Ext.</label
                      >
                      <input
                        type="tel"
                        class="form-control"
                        id="{{ 'additionalContactExt2' + i }}"
                        formControlName="ext2"
                      />
                    </div>
                    <div class="col-3">
                      <label
                        for="{{ 'additionalContactEmail' + i }}"
                        class="form-label"
                        >Email</label
                      >
                      <input
                        type="email"
                        class="form-control"
                        id="{{ 'additionalContactEmail' + i }}"
                        formControlName="email"
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        <div class="acrv-actions">
          <button
            type="button"
            class="btn btn-outline btn-sm"
            [disabled]="disabled"
            (click)="addContact()"
          >
            <i class="bi bi-plus-lg me-1"></i>
            Add contact
          </button>
          <div class="action-row justify-end">
            <button
              type="button"
              class="btn btn-ghost"
              [disabled]="disabled"
              (click)="cancel()"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              [disabled]="disabled"
              (click)="submit()"
            >
              Save vendor
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
}
